import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ApContentModule } from '@ap/content';
import { ApContentComponentsModule } from '@ap/content-components';

@NgModule({
    imports: [ApContentComponentsModule, ApContentModule, BrowserAnimationsModule],
    exports: [ApContentComponentsModule, ApContentModule, BrowserAnimationsModule]
})
export class BaseStarterAppModule {}
